import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/debounceTime';



//import * as FacturaModel from './CrearFactura.model';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { DialogoConfirmacionComponent } from '../DialogConfirmacion/dialogo-confirmacion.component';
import { MatSnackBar,MatSnackBarConfig  } from '@angular/material';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { resolveReflectiveProviders } from '@angular/core/src/di/reflective_provider';
import { MchSolicitudNotasId,SolicitudNotasModel } from './SolicitudNotas.model';



@Component({
	selector: 'SolicitudNotasForm',
	templateUrl: './SolicitudNotasForm.component.html',
})


export class SolicitudNotasFormComponent {

	public form: FormGroup;
	public formErrors: any;
	public solicitudNota: SolicitudNotasModel;
	public listaPatrimonios: Array<OpcionModel>;
	public listaPrefijos: Array<OpcionModel>;
	public cnumcont: OpcionModel;
	public ocultar: boolean = false;
	public mensaje: string = "";
	myControl = new FormControl();
	filteredOptions: Observable<OpcionModel[]>;

	public bloquearValor:boolean = true;
	public bloquearCampoEscritura:boolean = true;
	public btnConsultar: boolean;
	public valorTemporal: any;
	private perfil:any;
	private listadoPerfiles:any;
	public registroEscritura;
	private btnGuardar:boolean
	
	



	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog,public dialogo: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		this.btnGuardar = true;
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
	}


	ngOnInit() {
	
		this.cnumcont = new OpcionModel('', "");
		this.listaPatrimonios = new Array();
		this.solicitudNota = new SolicitudNotasModel (new MchSolicitudNotasId("","","",""),"",0,"","",new Date(),0);
		
		
		this._route.params.subscribe( params =>{
			this.registroEscritura = [{'cnumcont':params['cnumcont'], 
			'cid' :params['cid'],
			'formulario' :params['formulario']
		}];
		})
		
		if(this.registroEscritura[0].formulario== 3){
			this.btnGuardar = false;
			this.listaPrefijos = new Array();
			this._serviciosGenerales.get('solicitudNotaInformacion', {cid:this.registroEscritura[0].cid}).subscribe(result =>{
				for(let x of result){
					this.solicitudNota = new SolicitudNotasModel( new MchSolicitudNotasId(x.CID,x.VIDESCRITURA,x.CNUMCONT,x.CPREFIJO),x.NUMERO_FACTURA,x.VALOR,x.OBSERVACION,"",new Date(),0);                    		
					this._serviciosGenerales.get('negocioPorContrato', { cnumcont:x.CNUMCONT.trim() }).subscribe(
						result => {
							for (let x of result){
								this.listaPatrimonios.push(new OpcionModel(x.cnumcont, x.vnombrenegocio));
								this.cnumcont.labelOpcion = x.cnumcont+' - '+x.vnombrenegocio;
							}
						},
						error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBarEspecial("Ocurrió un error al momento de cargar las ciudades", "X");
						}
					);
					this.listaPrefijos.push(new OpcionModel(x.CPREFIJO.trim(),x.CPREFIJO.trim()));
				};
			}, 
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar las sucursales asociadas", "X");
	
			});
			/*
			
			*/
		}
		


		this.cargarInfo();


		this.filteredOptions = this.myControl.valueChanges
			.startWith(null)
			.map(val => val ? this.filter(val) : this.listaPatrimonios.slice());


		this.inicializarForm();
		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});	
	}

	
	inicializarForm() {
		this.formErrors = {
			cnumcont: {},
			ciddoc: {},
			observacion: {},
			valor:{},
		};


		this.form = this.formBuilder.group({
			cnumcont: ['', Validators.required],
			ciddoc: ['', Validators.required],
			observacion: [Validators.required],			
			valor: [Validators.required]
		});
	}

	filter(val: string)//: string[]
	{
		if (val == null) {
			val = "";
		}
		let x = this.listaPatrimonios.filter(option => (option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1);
		return x;
	}

	eventoConsulta() {
		
		this.listaPrefijos = new Array();
		this.cnumcont.idOpcion = this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-'));
		this.consultarPrefijos();
	}


	private cargarInfo() {


		this._serviciosGenerales.get('listaPatrimonios', { param: 0 }).subscribe(
			result => {
				for (let x of result) {
					this.listaPatrimonios.push(new OpcionModel(x.cnumcont, x.vnombrenegocio));
				}
			},
			error => {
				var errorMensaje = <any>error;

				this.ocultar = true;
				this.mensaje = "Procesando Información ..";

				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");
			});
	}

	
	consultarPrefijos() {
		this._serviciosGenerales.get('listaPrefijos', { cnumcont: this.cnumcont.idOpcion.trim() }).subscribe(
			result => {
				for (let x of result) {
					this.listaPrefijos.push(new OpcionModel(x.cprefijo.trim(),x.cprefijo.trim()));
				}
			},
			error => {
				var errorMensaje = <any>error;
				this.ocultar = true;
				this.mensaje = "Procesando Información ..";
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});
	}


	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}


	onBlurMethod(valor,campo){
		let temp = /\./gi;
		valor = valor.replace(temp,'').replace('$','').replace(',','.');
		if(!isNaN(Number(valor)) && campo == 'inmueble'){
			this.solicitudNota.valor = Number(valor);
		}
	}


	openSnackBar(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			this.ocultar = false;
			this.mensaje = "";
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		

		if (shand.length != 0) {
			for (let i=0;i<shand.length;i++){
			shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
	}

	guardar() {		
        /*
		if (this.form.valid == false) {
			this.openSnackBarEspecial("Faltan campos por diligenciar en el formulario  del prefijo asociado  ", "X");
			return;
		}*/

		if(this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-')).length == 0){
			this.openSnackBar("Se debe seleccionar un Negocio.", "X");
			return;
		}

		if(this.solicitudNota.id.cprefijo.length == 0){
			this.openSnackBar("Se debe seleccionar un Prefijo.", "X");
			return;
		}


		if(this.solicitudNota.numeroFactura.length == 0){
			this.openSnackBar("El campo # Documento no puede estar vacio.", "X");
			return;
		}

		if(this.solicitudNota.valor <=0){
			this.openSnackBar("El valor de la Nota debe ser mayor de cero", "X");
			return;
		}

		if(this.solicitudNota.observacion.length == 0){
			this.openSnackBar("El campo Observación no puede estar vacio.", "X");
			return;
		}



		this._serviciosGenerales.get('validarSiExisteFactura', { cnumcont: this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-')), cprefijo: this.solicitudNota.id.cprefijo, cnumdoc:this.solicitudNota.numeroFactura }).subscribe(
			result => {
				
				if(result[0].c == 0 ){
					this.openSnackBar("La factura "+this.solicitudNota.id.cprefijo+"-"+this.solicitudNota.numeroFactura+" No existe en el sistema", "X");
					return;
				}
				else{
					this._serviciosGenerales.get('validarEstadoDian', {prefijo: this.solicitudNota.id.cprefijo, cnumdoc:this.solicitudNota.numeroFactura }).subscribe(
						result => {
							
							if(result[0].cantidad > 0 ){
								this.openSnackBar("La factura "+this.solicitudNota.id.cprefijo+"-"+this.solicitudNota.numeroFactura+" no tiene estado aprobado por la DIAN", "X");
								return;
							}
							else{

								this._serviciosGenerales.get('validarSiExisteNota', {cnumcont: this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-')), cprefijo: this.solicitudNota.id.cprefijo, cnumdoc:this.solicitudNota.numeroFactura }).subscribe(
									result => {
										
										if(result[0].cantidad > 0 ){
											this.openSnackBar("Esta escritura ya tiene una nota solicitada", "X");
											return;
										}
										else{
												var d = new Date();
												this.solicitudNota.id.cid = d.getTime().toString();
												this.solicitudNota.vusuario =  this._serviciosGenerales.seguridad.getInfoSesion().usuario;
												this.solicitudNota.id.cnumcont = this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-'));
										
												this._serviciosGenerales.post('guardar/solicitudNotas', this.solicitudNota).subscribe(
													result => {
														this.openSnackBar("La Nota ha sido solicitada de forma exitosa", "X");
														this.solicitudNota = new SolicitudNotasModel (new MchSolicitudNotasId("","","",""),"",0,"","",new Date(),0);
													},
													error => {
														var errorMensaje = <any>error;
														console.log('Error al enviar la peticion ', errorMensaje);
														this.openSnackBar("Ocurrió un error al momento de guardar la sucursal", "X");
													}
												)
											}
								}, error => {
									var errorMensaje = <any>error;
									console.log('Error al enviar la peticion ', errorMensaje);
									this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
								});
							}
						}, error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
						});
				}

			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar el concepto", "X");
			});

	}

	

	bloquearBoton(){
		var count = 1;
		this.guardar();
	}
}



// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/SolicitudNotas/SolicitudNotasForm.component.ts